<template>
  <div class="big">
    <el-dialog
      title="请选择医生"
      :visible.sync="dialog"
      style="text-align: left"
      width="870px"
      custom-class="inquiryTem-doctor"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div class="addDoctorTemplate">
        <el-form :inline="true" :model="doctorForm" class="demo-form-inline">
          <el-form-item label="医生姓名">
            <el-input
              v-model="doctorForm.doctor_name"
              @input="searchClick"
              clearable
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="医生手机">
            <el-input
              v-model="doctorForm.phone"
              @input="searchClick"
              clearable
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchClick">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6; height: 400px">
          <el-table
            :data="doctorTableData"
            ref="doctorTableDataRef"
            tooltip-effect="dark"
            style="width: 100%; height: 400px; overflow: auto"
            :header-cell-style="{ background: '#F5F5F5' }"
            @row-click="singleElection"
          >
            <el-table-column label="" width="65" align="center">
              <template slot-scope="scope">
                <el-radio
                  class="radio"
                  v-model="templateSelection"
                  :label="scope.$index"
                  >&nbsp;</el-radio
                >
              </template>
            </el-table-column>

            <el-table-column
              v-for="(item, index) in headerTable"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              align="left"
            ></el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
      <div style="text-align: center; padding: 10px 0">
        <el-button @click="closeShow" size="medium">取 消</el-button>
        <el-button type="primary" @click="submit" size="medium"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../../../components/Pagination/index.vue';
import common from '../../../../api/common';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      dialog: true,
      templateSelection: false,
      doctorForm: {
        doctor_name: '',
        phone: ''
      },
      headerTable: [
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: '120'
        },
        {
          label: '手机号',
          prop: 'phone',
          width: 'auto'
        },
        {
          label: '医院',
          prop: 'hospital',
          width: '320'
        }
      ],
      doctorTableData: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doctorSelection: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      let params = Object.assign(this.doctorForm, this.pagination);
      common.getDoctorList(params).then((res) => {
        let { data } = res;
        this.doctorTableData = data.list;
        this.totalNum = data.total;
      });
    },
    // 选择医生
    singleElection(val) {
      this.doctorSelection = val;
    },
    closeShow() {
      this.$emit('closeShow');
    },
    // 查询
    searchClick() {
      this.getList();
    },
    //提交
    submit() {
      if (!this.doctorSelection) {
        this.$message.error('请选择医生');
        return;
      }
      this.$router.push({
        path: '/home/template/addOrEditorTem',
        query: {
          is_add: -1,
          doctor_id: this.doctorSelection.doctor_id,
          hospital: this.doctorSelection.hospital,
          phone: this.doctorSelection.phone,
          doctor_name: this.doctorSelection.doctor_name
        }
      });
    },
    close() {
      this.closeShow();
    }
  }
};
</script>
<style lang="scss" scoped>
.addDoctorTemplate {
  padding: 20px;
}
</style>
